// Single source of truth for the cap/rollback decision.
import { isEmpty } from "@swiggy-private/js-utils";
import { LOCAL_STORAGE_KEYS, LocalStorage } from "@swiggy-private/core-ui";
import { DEFAULT_FREQUENCY_CAP_VALUE, isToingFlow } from "@swiggy-private/checkout-core";
export const isAnimationCapExhausted = (maxFreq?: number): boolean => {
    if (isEmpty(maxFreq) || maxFreq === 0) {
        return true;
    }
    const saved = LocalStorage.getItem(
        LOCAL_STORAGE_KEYS.DELIVERY_MODE_ANIMATION_FREQUENCY_CAPPING_KEY,
        DEFAULT_FREQUENCY_CAP_VALUE,
    );
    return (saved?.counterValue ?? 0) >= maxFreq;
};

export const shouldStartDeliveryModeAnimation = ({
    hasPlayed,
    isAnimating,
    hasFtueData,
    maxFreq,
    shouldProceed,
}: {
    hasPlayed: boolean;
    isAnimating: boolean;
    hasFtueData: boolean;
    maxFreq?: number;
    shouldProceed: () => boolean;
}): boolean => {
    if (!isToingFlow() || hasPlayed || isAnimating) return false;
    if (!hasFtueData) return false;
    if (isAnimationCapExhausted(maxFreq)) return false;
    return shouldProceed();
};
